export const MODIFY_IMPORTER_MENU_ITEM = 'MODIFY_IMPORTER_MENU_ITEM';

export function modifyImporterMenuItem(importerMenuItem){
    return{
        type: MODIFY_IMPORTER_MENU_ITEM,
        mainState: {
            importerMenuItem: importerMenuItem
        }
    }
}